import { LAT, LNG } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

export default [
  {
    [LNG]: -215.8208287,
    [LAT]: 42.29515419,
  },
  {
    [LNG]: -214.5039194,
    [LAT]: 42.65198238,
  },
  {
    [LNG]: -213.643897,
    [LAT]: 43.20704846,
  },
  {
    [LNG]: -213.9395297,
    [LAT]: 44.15859031,
  },
  {
    [LNG]: -214.5039194,
    [LAT]: 45.030837,
  },
  {
    [LNG]: -215.4176932,
    [LAT]: 45.11013216,
  },
  {
    [LNG]: -216.600224,
    [LAT]: 45.34801762,
  },
  {
    [LNG]: -217.3527436,
    [LAT]: 45.9030837,
  },
  {
    [LNG]: -218.2665174,
    [LAT]: 46.10132159,
  },
  {
    [LNG]: -219.2071669,
    [LAT]: 46.14096916,
  },
  {
    [LNG]: -219.2340426,
    [LAT]: 44.67400881,
  },
  {
    [LNG]: -219.6371781,
    [LAT]: 43.96035242,
  },
  {
    [LNG]: -220.8197088,
    [LAT]: 42.88986784,
  },
  {
    [LNG]: -221.0615901,
    [LAT]: 41.74008811,
  },
  {
    [LNG]: -220.980963,
    [LAT]: 40.59030837,
  },
  {
    [LNG]: -220.980963,
    [LAT]: 38.84581498,
  },
  {
    [LNG]: -221.7066069,
    [LAT]: 38.72687225,
  },
  {
    [LNG]: -222.5128779,
    [LAT]: 38.37004405,
  },
  {
    [LNG]: -223.3729003,
    [LAT]: 38.01321586,
  },
  {
    [LNG]: -223.8835386,
    [LAT]: 37.37885463,
  },
  {
    [LNG]: -224.0716685,
    [LAT]: 36.46696035,
  },
  {
    [LNG]: -224.9854423,
    [LAT]: 36.18942731,
  },
  {
    [LNG]: -225.5767077,
    [LAT]: 36.11013216,
  },
  {
    [LNG]: -226.0604703,
    [LAT]: 36.18942731,
  },
  {
    [LNG]: -226.6517357,
    [LAT]: 36.62555066,
  },
  {
    [LNG]: -227.2698768,
    [LAT]: 36.58590308,
  },
  {
    [LNG]: -227.7267637,
    [LAT]: 36.030837,
  },
  {
    [LNG]: -228.1567749,
    [LAT]: 35.43612335,
  },
  {
    [LNG]: -228.9630459,
    [LAT]: 34.72246696,
  },
  {
    [LNG]: -229.8230683,
    [LAT]: 34.52422907,
  },
  {
    [LNG]: -230.1993281,
    [LAT]: 35.11894273,
  },
  {
    [LNG]: -231.2474804,
    [LAT]: 35.19823789,
  },
  {
    [LNG]: -231.9462486,
    [LAT]: 32.5814978,
  },
  {
    [LNG]: -231.4087346,
    [LAT]: 31.86784141,
  },
  {
    [LNG]: -230.6024636,
    [LAT]: 32.46255507,
  },
  {
    [LNG]: -230.6293393,
    [LAT]: 31.78854626,
  },
  {
    [LNG]: -230.7637178,
    [LAT]: 30.79735683,
  },
  {
    [LNG]: -231.2474804,
    [LAT]: 28.73568282,
  },
  {
    [LNG]: -232.0537514,
    [LAT]: 27.9030837,
  },
  {
    [LNG]: -233.075028,
    [LAT]: 27.030837,
  },
  {
    [LNG]: -234.1231803,
    [LAT]: 26.15859031,
  },
  {
    [LNG]: -235.5744681,
    [LAT]: 25.44493392,
  },
  {
    [LNG]: -236.0582307,
    [LAT]: 26.27753304,
  },
  {
    [LNG]: -237.106383,
    [LAT]: 25.96035242,
  },
  {
    [LNG]: -237.4557671,
    [LAT]: 24.17621145,
  },
  {
    [LNG]: -236.9182531,
    [LAT]: 23.70044053,
  },
  {
    [LNG]: -234.3650616,
    [LAT]: 24.57268722,
  },
  {
    [LNG]: -233.881299,
    [LAT]: 25.68281938,
  },
  {
    [LNG]: -233.1287794,
    [LAT]: 25.96035242,
  },
  {
    [LNG]: -231.8387458,
    [LAT]: 25.84140969,
  },
  {
    [LNG]: -230.9518477,
    [LAT]: 27.11013216,
  },
  {
    [LNG]: -230.1724524,
    [LAT]: 27.74449339,
  },
  {
    [LNG]: -228.7480403,
    [LAT]: 25.52422907,
  },
  {
    [LNG]: -228.4524076,
    [LAT]: 25.76211454,
  },
  {
    [LNG]: -230.1455767,
    [LAT]: 29.13215859,
  },
  {
    [LNG]: -229.6886898,
    [LAT]: 29.84581498,
  },
  {
    [LNG]: -228.9092945,
    [LAT]: 30.00440529,
  },
  {
    [LNG]: -228.5330347,
    [LAT]: 31.03524229,
  },
  {
    [LNG]: -228.1298992,
    [LAT]: 32.0660793,
  },
  {
    [LNG]: -227.3505039,
    [LAT]: 32.34361233,
  },
  {
    [LNG]: -226.4904815,
    [LAT]: 32.66079295,
  },
  {
    [LNG]: -225.4423292,
    [LAT]: 32.93832599,
  },
  {
    [LNG]: -224.6091825,
    [LAT]: 33.05726872,
  },
  {
    [LNG]: -223.3460246,
    [LAT]: 33.53303965,
  },
  {
    [LNG]: -222.2441209,
    [LAT]: 33.969163,
  },
  {
    [LNG]: -221.3034714,
    [LAT]: 34.1277533,
  },
  {
    [LNG]: -219.825308,
    [LAT]: 30.08370044,
  },
  {
    [LNG]: -218.6965286,
    [LAT]: 23.93832599,
  },
  {
    [LNG]: -218.2396417,
    [LAT]: 24.13656388,
  },
  {
    [LNG]: -218.5083987,
    [LAT]: 25.72246696,
  },
  {
    [LNG]: -217.4602464,
    [LAT]: 26.5154185,
  },
  {
    [LNG]: -217.7827548,
    [LAT]: 28.25991189,
  },
  {
    [LNG]: -218.9115342,
    [LAT]: 27.66519824,
  },
  {
    [LNG]: -220.1478163,
    [LAT]: 34.28634361,
  },
  {
    [LNG]: -219.1802912,
    [LAT]: 35.15859031,
  },
  {
    [LNG]: -218.6159015,
    [LAT]: 37.22026432,
  },
  {
    [LNG]: -217.5946249,
    [LAT]: 38.8061674,
  },
  {
    [LNG]: -217.5946249,
    [LAT]: 40.66960352,
  },
  {
    [LNG]: -218.5083987,
    [LAT]: 41.89867841,
  },
  {
    [LNG]: -216.4927212,
    [LAT]: 41.62114537,
  },
  {
    [LNG]: -215.8208287,
    [LAT]: 42.29515419,
  },
];
